import React, { useState } from "react";
import axiosInstance from "../axiosInstance";

export const useApprovalData = (contract, company_id) => {
    const [allUsers, setAllUsers] = useState([]);
    const [statusUsers, setStatusUsers] = useState([]);

    const fetchData = async () => {
        try {
            const statusRes = await axiosInstance.get(`/contract/check-status/${contract.id}/`);
            const statusData = statusRes?.data?.data || [];
            const res = await axiosInstance.post("/user/get_user_email/", { company_id, is_active: true });

            const usersData = (res?.data?.data || []).map((u) => ({
                ...u,
                remarks: u.remarks || "",
            }));
            setAllUsers(usersData);

            const mappedStatusUsers = statusData.map((s) => ({
                id: s.user_id,
                first_name: s.user_name,
                email: s.user_email,
                role: s.user_role || "User",
                scheduled_date: s.scheduled_date,
                status: s.status,
                approval_token: s.approval_token,
                approval_id: s.approval_id,
                remarks: s.remarks || "",
                remarks_grouped: {
                    send: s.remarks_grouped?.send || [],
                    reject: s.remarks_grouped?.reject || [],
                    not_required: s.remarks_grouped?.not_required || [],
                    update: s.remarks_grouped?.update || [],
                    other: s.remarks_grouped?.other || [],
                },
                agreement_status: s.agreement_status,
                created_at: s.created_at,
                updated_at: s.updated_at,
            }));
            setStatusUsers(mappedStatusUsers);
        } catch (err) {
            console.error(err);
        }
    };

    return { allUsers, setAllUsers, statusUsers, setStatusUsers, fetchData };
};
